module.exports = __webpack_public_path__ + "static/media/slack_icon.afc3691e.svg";